import React, { useEffect, useState } from 'react'
import { Modal, Spinner, Button } from 'react-bootstrap';
import { pythonAxiosInstance } from '../../config/ConfigInfo';
import { useNavigate } from 'react-router-dom';
import { clearItem, getItem, setItem } from '../../config/localStorage';
import { jwtDecode } from 'jwt-decode';

function UploadPdf(props) {

    const navigate = useNavigate();
    const [reumePdf, setResumePdf] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [disable, setDisable] = useState(false);

    const [reuseToken, setReuseToken] = useState('');
    const [reusePythonToken, setPythonReuseToken] = useState('');
    const reuseResumeBuildType = 'continue-resume';

    useEffect(() => {
        setReuseToken(getItem('token'));
        setPythonReuseToken(getItem('authToken'))
    }, [reuseToken, reusePythonToken])
    

    const handelSendPdf = async (e) => {
        e.preventDefault();
        setSuccess('');

        /** clear the local storage and set the token again start  */
        clearItem();
        setItem('token', reuseToken);
        setItem('authToken', reusePythonToken);
        setItem('resumeBuildType', reuseResumeBuildType);
        /** clear the local storage and set the token again end  */

        const maxFileSize = 1024 * 1024; // 1 MB file size

        if (!reumePdf) {
            setError('Please select a resume pdf file!');
            return;
        }

        if (reumePdf.type !== 'application/pdf') {
            setError('Please upload a valid resume pdf file!');
            return;
        }

        if (reumePdf.size > maxFileSize) {
            setError('File size should be less than 1 MB.');
            return;
        }

        // File is valid, proceed with upload
        setIsLoading(true);
        const getUserId = jwtDecode(getItem('token'));

        const formData = new FormData();
        formData.append('resumeUploadUserId', getUserId?.UserID || null); // Added the login userId
        formData.append('pdfFile', reumePdf);

        try {
            setDisable(true);
            const userResponse = await pythonAxiosInstance.post("parsing-resume/", formData, {
                headers: {
                    "Content-type": "application/file",
                }
            });

            if (userResponse?.status === 200 && userResponse?.data?.status === 'success') {
                setDisable(false);

                // profile data 
                if (userResponse?.data?.profileDetailInfo) {
                    const ProfileData = {
                        firstName: userResponse?.data?.profileDetailInfo?.first_name ?? '',
                        lastName: userResponse?.data?.profileDetailInfo?.last_name ?? '',
                        email: userResponse?.data?.profileDetailInfo?.email ?? '',
                        phone: userResponse?.data?.profileDetailInfo?.phone ?? '',
                        state: userResponse?.data?.profileDetailInfo?.state ?? '',
                        city: userResponse?.data?.profileDetailInfo?.city ?? '',
                        country: userResponse?.data?.profileDetailInfo?.country ?? ''
                    };

                    const jsonDataPro = JSON.stringify(ProfileData);
                    setItem('profileData', jsonDataPro);

                    if (userResponse?.data?.profileDetailInfo?.profile_image_url) {
                        const ProfileImageData = userResponse?.data?.profileDetailInfo?.profile_image_url ?? '';
                        if (ProfileImageData) {
                            setItem('profileImage', ProfileImageData);
                        }
                    }
                }

                // resume job title
                if(userResponse?.data?.resumeJobTitle){
                    setItem('jobTitle',userResponse?.data?.resumeJobTitle);
                }

                //Experience data 
                if (userResponse?.data?.experienceDetailInfo) {
                    const formattedData = userResponse?.data?.experienceDetailInfo?.map(item => ({
                        jobTitle: item?.jobTitle,
                        jobDescription: item?.jobDescription,
                        employer: item?.employer,
                        location: item?.location === null ? 'N/A' : item?.location,
                        startDate: item?.startDate,
                        endDate: item?.endDate === 'Present' ? null : item?.endDate,
                        currentlyWorkHere: item?.currentlyWorkHere
                    }));
                    const jsonExperienceData = JSON.stringify(formattedData);
                    setItem('experienceData', jsonExperienceData);
                }

                // Education 
                if (userResponse?.data?.educationDetailInfo) {
                    const formattedEducationData = userResponse?.data?.educationDetailInfo?.map(item => ({
                        schoolName: item?.schoolName,
                        schoolLocation: item?.schoolLocation === null ? 'N/A' : item?.schoolLocation,
                        schoolDegree: item?.schoolDegree,
                        schoolFieldOfStudy: item?.schoolFieldOfStudy,
                        schoolYearOfCompletion: item?.schoolYearOfCompletion
                    }));
                    const jsonEducationData = JSON.stringify(formattedEducationData);
                    setItem('educationData', jsonEducationData);
                }

                // skills List
                if (userResponse?.data?.SkillItemInfo) {
                    const formattedSkillData = userResponse?.data?.SkillItemInfo?.map(skillItemList => `<p>${skillItemList}</p>`).join('');
                    setItem("ratingItem", formattedSkillData);
                }

                // skills List with rating number
                if (userResponse?.data?.SkillItemWithRating) {
                    const jsonSkillItemWithRatingData = JSON.stringify(userResponse?.data?.SkillItemWithRating);
                    setItem("rating", jsonSkillItemWithRatingData);
                }

                // summary list
                if (userResponse?.data?.summaryItemInfo) {
                    const summaryItemInfoData = "<p>" + userResponse.data.summaryItemInfo + ".</p>";
                    setItem("summaryItem", summaryItemInfoData);
                }

                // finalize Personal Details  
                if (userResponse?.data?.personalDetailsInfo) {
                    const personalDetailsInfoData = JSON.stringify(userResponse?.data?.personalDetailsInfo);
                    setItem("personalDetailsData", personalDetailsInfoData);
                    setItem("personalDetails", true);
                }

                // finalize webPortProfile Details  
                if (userResponse?.data?.webPortProfileInfo) {
                    const webPortProfileInfoData = JSON.stringify(userResponse?.data?.webPortProfileInfo);
                    setItem("webPortProfileData", webPortProfileInfoData);
                    setItem("webPortProfile", true);
                }

                // finalize accomplishments Details  
                if (userResponse?.data?.accomplishmentsInfo) {
                    const accomplishmentsInfoData = userResponse?.data?.accomplishmentsInfo?.map(accomplishmentsList => `<p>${accomplishmentsList}</p>`).join('');
                    setItem("accomplishmentsData", accomplishmentsInfoData);
                    setItem("accomplishments", true);
                }

                // finalize affiliations Details  
                if (userResponse?.data?.affiliationsInfo) {
                    const affiliationsInfoData = userResponse?.data?.affiliationsInfo?.map(affiliationsList => `<p>${affiliationsList}</p>`).join('');
                    setItem("affiliationsData", affiliationsInfoData);
                    setItem("affiliations", true);
                }

                // finalize additional Information Details
                if (userResponse?.data?.additionalInformationInfo) {
                    const additionalInformationInfoData = "<p>" + userResponse.data.additionalInformationInfo + ".</p>";
                    setItem("additionalInformationData", additionalInformationInfoData);
                    setItem("additionalInformation", true);
                }

                // finalize languages Details
                if (userResponse?.data?.languagesDataInfo) {
                    const languagesInfoData = JSON.stringify(userResponse?.data?.languagesDataInfo);
                    setItem("languagesData", languagesInfoData);
                    setItem("languages", true);
                }

                // finalize certifications Details
                if (userResponse?.data?.certificationsDataInfo) {
                    const certificationsInfoData = JSON.stringify(userResponse?.data?.certificationsDataInfo);
                    setItem("certificationsData", certificationsInfoData);
                    setItem("certifications", true);
                }

                // finalize interests Details
                if (userResponse?.data?.interestsDataInfo) {
                    const interestsInfoData = JSON.stringify(userResponse?.data?.interestsDataInfo);
                    setItem("interestsData", interestsInfoData);
                    setItem("interests", true);
                }

                // finalize hobbies Details
                if (userResponse?.data?.hobbiesDataInfo) {
                    const hobbiesInfoData = JSON.stringify(userResponse?.data?.hobbiesDataInfo);
                    setItem("hobbiesData", hobbiesInfoData);
                    setItem("hobbies", true);
                }

                navigate('/review-resume', { state: { setReviewResume: true, hideBackButton: true } });
                setIsLoading(false);
            } else {
                setSuccess('');
                setResumePdf(null)
                setError(userResponse?.data?.message);
                setIsLoading(false);
                setDisable(false);
            }
        } catch (error) {
            setError("Oops, Something went wrong please try again!");
            setIsLoading(false);
            setDisable(false);
        }
    }

    const handlePdfFlie = (e) => {
        const selectedFile = e.target.files[0];
        setResumePdf(selectedFile);
    };

    return (
        <>
            {/* modal section start here  */}
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='continue-model-section'
                backdrop='static'
            >
                <Modal.Header>
                    <div className='col-md-12 text-end'>
                        <Button variant="light" onClick={props.onHide} disabled={disable} ><i className="fa fa-times"></i></Button>
                    </div>
                </Modal.Header>

                <Modal.Body>
                    {isLoading &&
                        <>
                            <div className="d-flex flex-column align-items-center justify-content-center uploadResumeLoader">
                                <div className="row">
                                    <Spinner animation="border" variant="primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                                </div>
                                <div className="row">
                                    <div className='col-md-12 mt-3'>
                                        <strong>Fetching Pdf resume data. Please be patient, This process may take up to a minute!</strong>
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    {
                        !isLoading &&
                        <>
                            <h4>Upload Resume PDF</h4>
                            <div className='create-continue-section text-center'>
                                <form className="row g-3" id="upload-pdf-form">
                                    <div className="col-md-9">
                                        <div className="mb-3">
                                            <input className="form-control" type="file" id="formFile" accept="application/pdf" onChange={handlePdfFlie} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <button type="submit" className="btn btn-primary button-green mb-3 w-100" onClick={(e) => { handelSendPdf(e) }}>Upload</button>
                                    </div>
                                    {
                                        error ?
                                            <div className="alert alert-danger" role="alert">
                                                {error}
                                            </div>
                                            : ''
                                    }
                                    {
                                        success ?
                                            <div className="alert alert-success" role="alert">
                                                {success}
                                            </div>
                                            : ''
                                    }
                                </form>
                            </div>
                        </>
                    }
                </Modal.Body>
            </Modal>
            {/* modal section end here  */}
        </>
    )
}

export default UploadPdf
